import { RadioButtonChecked } from "@mui/icons-material";
import { Box, Button, keyframes, Slide, useMediaQuery } from "@mui/material";
import { ChatPopupHelper } from "mui-toolkit/chatPopup/ChatPopupHelper";

import { HeyTilleyIcon } from "../components/Icons/Icons";
import useChatPopup from "../hooks/useChatPopup";

const scaledown = keyframes`
  0% { transform: scale(1) }
  50% { transform: scale(.8) }
  100% { transform: scale(1) }
`;

const scaleup = keyframes`
  0% { transform: scale(1) }
  50% { transform: scale(1.3) }
  100% { transform: scale(1) }
`;

export const HeyTilleyButton = ({ onChangeRecords, isOpen }) => {
  const {
    showPopup,
    setShowPopup,
    currentTranscript,
    listening,
    elapsedTime,
    handleStartRecording,
    handleStopRecording,
    resetTranscript,
    promptName,
  } = useChatPopup({ systemPrompt: null });

  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });

  const handleChatCompletion = (_affectedRecords) => {
    resetTranscript();
    if (_affectedRecords && Array.isArray(_affectedRecords)) {
      onChangeRecords?.(_affectedRecords);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          "&:hover .big-star": {
            animation: `${scaledown} 1.2s ease-in-out 0s infinite`,
            transformOrigin: "center",
            transformBox: "fill-box",
          },
          "&:hover .small-star": {
            animation: `${scaleup} 1.2s ease-in-out 0s infinite`,
            transformOrigin: "center",
            transformBox: "fill-box",
          },
        }}
      >
        <Button
            onClick={() => {
              if (listening) {
                handleStopRecording();
              } else {
                setShowPopup(true);
              }
            }}
            variant="contained"
            color={listening ? "error" : "primary"}
            sx={{
              minWidth: "inherit",
              position: isSmall ? "fixed" : "relative",
              bottom: isSmall ? "20px" : "auto",
              right: isSmall ? (isOpen ? "80px" : "120px") : "auto",
              display: isSmall && !isOpen ? "none" : "inline-flex",
              gap: "8px",
            }}
          >
            {!isSmall && <span>Hey, Tilley</span>}
            {listening ? (
              <RadioButtonChecked className="pulsating" />
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 9.77778V14.2222M8 6.44444V17.5556M12 2V22M16 9.77778V14.2222M20 6.44444V17.5556"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <Box
              sx={{
                position: "absolute",
                right: "-4px",
                top: "-4px",
              }}
            >
              <HeyTilleyIcon sx={{ width: "28px", height: "28px" }} color="secondary" />
            </Box>
          </Button>
      </Box>
      {isSmall && showPopup && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 16%)",
            zIndex: 1399,
            transition: "opacity 0.3s ease",
          }}
        />
      )}
      <Slide direction="up" in={showPopup} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            bottom: isSmall ? "6px" : "46px",
            right: isSmall ? "unset" : "10px",
            width: isSmall ? "100%" : "450px",
            maxHeight: "calc(100vh - 138px)",
            height: "100%",
            zIndex: 1400,
            padding: "8px",
            left: isSmall && "0px",
          }}
        >
          <Box sx={{ height: "100%" }}>
            <ChatPopupHelper
              showPopup={showPopup}
              onChatCompletion={handleChatCompletion}
              userMessage={currentTranscript}
              promptName={promptName}
              onClose={() => setShowPopup(false)}
              onStopRecording={handleStopRecording}
              onStartRecording={handleStartRecording}
              listening={listening}
              elapsedTime={elapsedTime}
            />
          </Box>
        </Box>
      </Slide>
    </>
  );
};
